import React, { cloneElement, Fragment } from "react";
import { useDispatch } from "react-redux";
import { setAnsweringQuestionsAction, checkAnswerForInspectionAction } from "../../../../redux/answeringQuestions/answeringQuestions";

const NotEnteredAnswerChecker = ( props ) => {

  const dispatch = useDispatch();
  const setAnsweringQuestions = payload => { dispatch( setAnsweringQuestionsAction( payload ) ) };
  const checkAnswerForInspection = () => { dispatch( checkAnswerForInspectionAction() ) };

  const hide = () => {
    setAnsweringQuestions( { isShowNotEnteredAnswerPopup : false } );
  };

  return cloneElement( props.children || <Fragment />, {
    onConfirm : checkAnswerForInspection,
    onHide : hide
  } );

};

export default NotEnteredAnswerChecker;
